import { clsx } from "clsx";
import styles from "./LandingHeading.module.scss";

interface LandingHeadingProps {
  lines: string[];
  // On a photo: every line in white, no gradient.
  isLight?: boolean;
  className?: string;
}

// A landing page section title: uppercase, the first line in the brand
// gradient.
export function LandingHeading({
  lines,
  isLight = false,
  className,
}: LandingHeadingProps) {
  return (
    <h2
      className={clsx(styles.root, isLight && styles["root--light"], className)}
    >
      {lines.map((line, index) => (
        <span
          key={line}
          className={clsx(index === 0 && !isLight && styles.accent)}
        >
          {line}
        </span>
      ))}
    </h2>
  );
}
